import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { BehaviorSubject, Observable } from 'rxjs'
import { BatchTracingSpec } from '../../spec/batch-tracing-spec'
import { BatchTracingConf } from '../batch-tracing-conf'
import {
  ElderFormFieldDenseDirective,
  ElderPlugParentFormDirective,
  ElderSelectComponent,
  UuidUtil,
} from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { VendorSelectDirective } from '../../vendors/vendor-select.directive'
import { FormsModule } from '@angular/forms'
import { MatInput } from '@angular/material/input'
import { MatFormField } from '@angular/material/form-field'
import { AsyncPipe } from '@angular/common'

@Component({
  selector: 'app-batch-tracing-conf-detail',
  templateUrl: './batch-tracing-conf-detail.component.html',
  styleUrls: ['./batch-tracing-conf-detail.component.scss'],
  imports: [
    ElderPlugParentFormDirective,
    MatFormField,
    ElderFormFieldDenseDirective,
    MatInput,
    FormsModule,
    ElderSelectComponent,
    VendorSelectDirective,
    AsyncPipe,
    ElderTranslatePipe,
  ],
})
export class BatchTracingConfDetailComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  public readonly uuid = UuidUtil.weakUuid4()

  private readonly _spec$ = new BehaviorSubject<BatchTracingSpec>(null)
  private readonly _conf$ = new BehaviorSubject<BatchTracingConf>(null)

  @Input()
  public embedded = false

  @Output()
  public close: EventEmitter<Event> = new EventEmitter<Event>()

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Getter / Setters                                                        *
   *                                                                         *
   **************************************************************************/

  public get spec$(): Observable<BatchTracingSpec> {
    return this._spec$.asObservable()
  }

  public get spec(): BatchTracingSpec {
    return this._spec$.getValue()
  }

  @Input()
  public set spec(spec: BatchTracingSpec) {
    if (spec) {
      this._spec$.next(spec)
    }
  }

  public get conf$(): Observable<BatchTracingConf> {
    return this._conf$.asObservable()
  }

  public get conf(): BatchTracingConf {
    return this._conf$.getValue()
  }

  @Input()
  public set conf(conf: BatchTracingConf) {
    if (conf) {
      this._conf$.next(conf)
    }
  }

  /***************************************************************************
   *                                                                         *
   * Component Events                                                        *
   *                                                                         *
   **************************************************************************/

  public onVendorSelectionChange(vendorId: string): void {
    if (vendorId && this.conf) {
      this.conf.vendor = vendorId.toString()
    }
  }

  public onClose(event: Event): void {
    this.emitClose(event)
  }

  /***************************************************************************
   *                                                                         *
   * Private Methods                                                         *
   *                                                                         *
   **************************************************************************/

  private emitClose(event?: Event): void {
    this.close.emit(event)
  }
}
